// extracted by css-extract-rspack-plugin
export default {"DescriptionText":"KjIup"};